import { TableActionMenu, type TableActionItem } from '@/components/shared';
import type { OrganizationSalesFilter } from '../types';

const SALES_FILTER_OPTIONS: Array<{
  value: OrganizationSalesFilter;
  label: string;
}> = [
  { value: 'all', label: 'All statuses' },
  { value: 'completed', label: 'Completed' },
  { value: 'partially_refunded', label: 'Partially refunded' },
  { value: 'refunded', label: 'Refunded' },
  { value: 'canceled', label: 'Canceled' },
  { value: 'pending', label: 'Pending' },
];

export interface OrganizationSalesFiltersProps {
  filter: OrganizationSalesFilter;
  actions?: TableActionItem[];
  onFilterChange: (value: OrganizationSalesFilter) => void;
}

export function OrganizationSalesFilters({
  filter,
  actions = [],
  onFilterChange,
}: OrganizationSalesFiltersProps) {
  return (
    <div className="flex flex-wrap items-end gap-3 border-b border-neutral-200 bg-neutral-50 px-5 py-4">
      <label className="flex min-w-[220px] flex-col gap-1 text-small font-medium text-neutral-700">
        Status
        <select
          value={filter}
          onChange={(event) => onFilterChange(event.target.value as OrganizationSalesFilter)}
          className="h-10 rounded-lg border border-neutral-200 bg-white px-3 text-body text-neutral-900"
        >
          {SALES_FILTER_OPTIONS.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </label>

      {actions.length > 0 ? (
        <div className="ml-auto flex min-w-[2.5rem] justify-end">
          <TableActionMenu actions={actions} label="Sales table actions" />
        </div>
      ) : null}
    </div>
  );
}
